import React from 'react';
import { Badge } from 'reactstrap';

const LabelFormatter = props => (
  <div>
    {props.value === "Trail" ? <Badge color="warning">{props.value}</Badge> : null}
    {props.value === "Trail Expired" ? <Badge color="warning">{props.value}</Badge> : null}
    {props.value === "Activated" ? <Badge color="primary">{props.value}</Badge> : null}
    {props.value === "Active" ? <Badge color="primary">{props.value}</Badge> : null}
    {props.value === "Paid" ? <Badge color="success">{props.value}</Badge> : null}
    {props.value === "Cancelled" ? <Badge color="danger">{props.value}</Badge> : null}
    {props.value === "Cancellation Requests" ? <Badge color="warning">{props.value}</Badge> : null}
    {props.value === "suspended" ? <Badge color="danger">{props.value}</Badge> : null}
  </div>
);

export default LabelFormatter;
